import { useTranslate } from "@refinedev/core";

export const useMediaTypeOptions = () => {
  const translate = useTranslate();

  const getMediaTypeOptions = () => [
    { value: "", label: translate("options.none") },
    { value: "book", label: translate("options.media_type.book") },
    { value: "magazine", label: translate("options.media_type.magazine") },
    { value: "magazine-partiu", label: translate("options.media_type.magazine_partiu") },
    { value: "audiobook", label: translate("options.media_type.audiobook") },
  ];

  return { getMediaTypeOptions };
};
